import {
  opArtifactMembershipCollection,
  opArtifactMembershipVersionIndex,
  opArtifactName,
  opArtifactProject,
  opArtifactType,
  opArtifactTypeName,
  opDict,
  opEntityName,
  opProjectEntity,
  opProjectName,
  OutputNode,
} from '@wandb/weave-ui/cg';
import {useNodeValue} from '@wandb/weave-ui/cgreact';
import * as Panel2 from '@wandb/weave-ui/components/Panel2/panel';
import * as React from 'react';

import {Highlight, Python} from '../../../components/Code';
const inputType = 'artifactMembership' as const;
type ConfigType = {};

export const PanelArtifactMembershipAPI: React.FC<
  Panel2.PanelProps<typeof inputType, ConfigType>
> = ({input: artifactMembershipNode}) => {
  const {loading, result} = useNodeValue(
    React.useMemo(() => {
      const artifactNode = opArtifactMembershipCollection({
        artifactMembership: artifactMembershipNode,
      });
      const artifactTypeNode = opArtifactType({artifact: artifactNode});
      const artifactProjectNode = opArtifactProject({
        artifact: artifactNode,
      });
      return opDict({
        artifactTypeName: opArtifactTypeName({
          artifactType: artifactTypeNode,
        }),
        entityName: opEntityName({
          entity: opProjectEntity({
            project: artifactProjectNode,
          }),
        }),
        projectName: opProjectName({
          project: artifactProjectNode,
        }),
        artifactName: opArtifactName({
          artifact: artifactNode,
        }),
        versionIndex: opArtifactMembershipVersionIndex({
          artifactMembership: artifactMembershipNode,
        }),
      } as any) as unknown as OutputNode<'any'>;
    }, [artifactMembershipNode])
  );

  if (loading) {
    return <></>;
  }
  return (
    <Python>
      <Highlight iconOnly>
        {`import wandb
run = wandb.init()
artifact = run.use_artifact('${result.entityName}/${result.projectName}/${result.artifactName}:v${result.versionIndex}', type='${result.artifactTypeName}')
artifact_dir = artifact.download()`}
      </Highlight>
    </Python>
  );
};
